var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBsc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    className: "NetworkName-module--icon--cZ5BC",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.199 7.144l3.3-3.302 3.304 3.303 1.921-1.92L8.5 0 3.278 5.223l1.92 1.92zM3.842 8.5L1.921 6.579 0 8.499l1.92 1.922L3.843 8.5zM5.199 9.856l3.3 3.302 3.304-3.303 1.922 1.92h-.001L8.5 17l-5.225-5.225 1.924-1.919zM15.079 10.422L17 8.5 15.08 6.58 13.157 8.5l1.921 1.922z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.448 8.499h.001L8.5 6.549 6.55 8.5l.003.004L8.5 10.45l1.95-1.949V8.5l-.002-.001z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.38ded3cd.svg";
export { ForwardRef as ReactComponent };